import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { COURSE_APP_URL } from '../lib/site';
import { Logo } from './Bits';

const LINKS = [
  { to: '/courses', label: 'For courses' },
  { to: '/why', label: 'Why MyGolfLinks' },
  { to: '/golfers', label: 'For golfers' },
  { to: '/partners', label: 'For partners' },
  { to: '/pricing', label: 'Pricing' },
  { to: '/about', label: 'About' },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header className={`nv${scrolled || open ? ' scrolled' : ''}`}>
      <div className="nv-in">
        <Link to="/" className="nv-logo" aria-label="MyGolfLinks home">
          <Logo />
        </Link>

        <nav className="nv-links" aria-label="Primary">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} className={({ isActive }) => (isActive ? 'active' : undefined)}>
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="nv-cta">
          <a className="nv-signin" href={COURSE_APP_URL}>Course sign in</a>
          <Link to="/demo" className="btn btn-gold btn-sm">Book a demo</Link>
          <button
            type="button"
            className="nv-burger"
            aria-expanded={open}
            aria-controls="mobile-menu"
            aria-label={open ? 'Close menu' : 'Open menu'}
            onClick={() => setOpen((v) => !v)}
          >
            <span /><span /><span />
          </button>
        </div>
      </div>

      <nav id="mobile-menu" className={`nv-menu${open ? ' open' : ''}`} aria-label="Mobile">
        {LINKS.map((l) => (
          <Link key={l.to} to={l.to}>{l.label}</Link>
        ))}
        <a href={COURSE_APP_URL}>Course sign in</a>
        <Link to="/demo" className="btn btn-gold">Book a demo</Link>
      </nav>
    </header>
  );
}
